import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllGarages = createAsyncThunk('garages/getAllGarages', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/garages`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const addGarages = createAsyncThunk('garages/addGarages', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/garages`, { ..._ });

    thunkAPI.dispatch(getAllGarages());

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteGarages = createAsyncThunk('garages/deleteGarages', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/garages/${id}`);

    thunkAPI.dispatch(getAllGarages());

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateGarages = createAsyncThunk('garages/updateGarages', async ({ id, payload }, thunkAPI) => {
  try {
    await axiosInstance.put(`/garages/${id}`, { ...payload });

    thunkAPI.dispatch(getAllGarages());
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getGarageDetail = createAsyncThunk('garages/getGarageDetail', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/garages/${id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getGarageAdditionalSettings = createAsyncThunk(
  'garages/getGarageAdditionalSettings',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/outside-operational-settings/garage/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const createGarageAdditionalSettings = createAsyncThunk(
  'garages/createGarageAdditionalSettings',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`/outside-operational-settings`, { ...payload });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const updateGarageAdditionalSettings = createAsyncThunk(
  'garages/updateGarageAdditionalSettings',
  async ({ payload, id }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(`/outside-operational-settings/${id}`, { ...payload });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const deleteGarageAdditionalSettings = createAsyncThunk(
  'garages/deleteGarageAdditionalSettings',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`/outside-operational-settings/${id}`);

      thunkAPI.dispatch(getAllGarages());

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
